import { ref } from 'vue'

let currentZIndex = 1000

export const useZIndex = () => {
  const zIndex = ref(currentZIndex++)

  return {
    zIndex,
    nextZIndex: () => {
      zIndex.value = currentZIndex++
      return zIndex.value
    },
  }
}
